<script setup lang="ts">
  import PolygonShapeFileUpload from '@/components/shapeFileUpload/PolygonShapeFileUpload.vue'
  import { useSectionLinesStore } from '@/stores/sectionLine'

  const sectionLineStore = useSectionLinesStore()
  const { addPolygonShapeFileDialog } = storeToRefs(sectionLineStore)
  const props = defineProps({
    collection: { type: Object, required: true }
  })
</script>

<template>
  <v-dialog v-model="addPolygonShapeFileDialog" max-width="600">
    <v-card class="pa-3 pt-6">
      <v-card-title> Upload profiles</v-card-title>
      <PolygonShapeFileUpload :collection="props.collection" />
    </v-card>
  </v-dialog>
</template>
